//将xxx.js替换成需要发布的配置js文件
import {
	apiMall,
	javaApi,
	appName,
	isOverseas,
	unit,
	footCopyrightInfo,
	footRecordInformation,
	appId,
	isH5,
	h5Url,
	scanToOrderMsg
} from '@/api/config/prod_hanlianglobalxmn.js'

export const config = {
	apiMall,
	javaApi,
	appName,
	isOverseas,
	unit,
	footCopyrightInfo,
	footRecordInformation,
	appId,
	isH5,
	h5Url,
	scanToOrderMsg
}
